module.exports = __webpack_public_path__ + "static/city-morning-dd249cb30861ddfa470c3e56aeb30e3d.mp4";